
















































import Vue from "vue";
import { Form } from "element-ui";
import { saveOrUpdate, getMenuList } from "@/api/menu";

export default Vue.extend({
  name: "MenuAddOrUpdate",
  data() {
    return {
      form: {
        name: "",
        href: "",
        parentId: -1,
        description: "",
        icon: ""
      },
      rules: {
        name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        href: [{ required: true, message: "请输入菜单路径", trigger: "blur" }],
        description: [{ required: true, message: "请输入菜单描述", trigger: "blur" }],
        icon: [{ required: true, message: "请输入菜单图标", trigger: "blur" }]
      },
      menuList: [],
      dialogFormVisible: false
    };
  },
  methods: {
    add() {
      this.form = {
        name: "",
        href: "",
        parentId: -1,
        description: "",
        icon: ""
      };
      this.dialogFormVisible = true;
      this.getMenuList();
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
      });
    },
    editor(row: any) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogFormVisible = true;
      this.getMenuList();
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
      });
    },
    async getMenuList() {
      const { data } = await getMenuList();
      if (data.code === "000000") {
        this.menuList = data.data;
      }
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(async (valid) => {
        if (valid) {
          const { data } = await saveOrUpdate(this.form);
          if (data.code === "000000") {
            this.$message.success("保存成功");
            this.dialogFormVisible = false;
            this.$emit("ok");
          } else {
            this.$message.error(data.mesg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
});
